module.exports = {

    'title_landing_pages': '促销',
    'description_landing_pages': '阿雅娜会员礼遇提供精彩诱人住宿玩乐套餐，满足您的旅行生活方式。',
    'crumb_home': '首页',
    'crumb_promotion': '促销',
}